import { useMutation } from 'react-query'
import { putAPI } from 'framework/api/http'

interface UpdateShipmentPackageInterface {
  warehouseOrderId: string
  shipmentId: string
  packageId: string
  packageDetails: any[]
}

export const useUpdateShipmentPackage = () => {
  const mutate = useMutation(
    async ({
      shipmentId,
      warehouseOrderId,
      packageId,
      packageDetails,
    }: UpdateShipmentPackageInterface) => {
      const [packageData] = packageDetails
      const mappedPackages = {
        type: packageData.type,
        qty: Number(packageData.qty),
        width: Number(packageData.width),
        height: Number(packageData.height),
        length: Number(packageData.length),
        weight: Number(packageData.weight),
      }

      return putAPI(
        `/WarehouseOrder/${warehouseOrderId}/Shipments/${shipmentId}/package/${packageId}`,
        mappedPackages,
      )
    },
  )

  return mutate
}

export default useUpdateShipmentPackage
